export default {"src":"/_next/static/media/ant.2730704a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};